<template>
  <div class="a-img">
    <div>
      <div class="title" v-if="is_show">成绩展示</div>
      <div class="title noline" v-else></div>
      <a-row :gutter="16" style="margin-bottom: 12px">
        <a-col :span="24" style="margin-bottom: 12px">
          <a-select v-model="gid" style="width: 100%" @change="group_change">
            <a-select-option v-for="item in g_list" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
        <a-col :span="24" v-if="is_show">
          <a-select :disabled="current_group.exist_child != 1" v-model="item_id" style="width: 100%" @change="item_change">
            <a-select-option v-for="item in item_list" :key="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
      <div class="img-list">
        <div v-for="(img, i) in team" :key="i" class="img-item">
          <img @click="show_img(img.imgurl)" style="width: 100%" :src="img.imgurl" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  computed: {
    is_show() {
      return true
    },
  },
  data() {
    return {
      columns: [
        {
          title: '排名',
          dataIndex: 'rank',
        },
        {
          title: '姓名/队伍',
          dataIndex: 'name',
        },
      ],
      update_time: '',
      team: [],
      gid: '',
      g_list: [],
      item_id: '',
      item_list: [],
      current_group: {},
      matchid: this.$route.params.matchid,
    }
  },
  mounted() {
    this.get_group()

    let hfz = document.documentElement.clientWidth / 2

    document.documentElement.style.fontSize = (hfz > 100 ? hfz : 100) + 'px'
  },
  methods: {
    show_img(url) {
      const urls = []

      this.team.forEach((row) => {
        urls.push(row.imgurl)
      })

      ImagePreview(urls)
    },
    group_change(e) {
      this.item_id = ''
      this.item_list = []
      this.current_group = this.g_list.find((row) => {
        return row.id === this.gid
      })
      if (this.current_group.exist_child == 1) {
        this.get_item_list()
      } else {
        this.get_rank_list()
      }
    },
    item_change(e) {
      this.get_rank_list()
    },
    get_rank_list() {
      this.team = []
      const query = {
        matchid: this.matchid,
        groupid: this.item_id || this.gid,
      }
      this.$api.match.imgRankList(query).then((r) => {
        this.team = r.data.list
      })
    },
    get_item_list() {
      this.$api.match.imgGroupList({
        matchid: this.matchid,
        pid: this.gid,
      })
        .then((r) => {
          if (r.status == 200) {
            const list = r.data

            this.item_list = list
            this.item_id = list[0].id
          }
        })
        .then((r) => {
          this.get_rank_list()
        })
    },
    get_group() {
      this.$api.match.imgGroupList({ matchid: this.matchid })
        .then((r) => {
          if (r.status == 200) {
            const list = r.data
            // r.data.forEach((row) => {
            //   if (row.type == 1) {
            //     list.push(row)
            //   }
            // })
            this.g_list = list
            this.current_group = list[0]
            this.gid = list[0].id
          }
        })
        .then((r) => {
          if (this.current_group.exist_child == 1) {
            this.get_item_list()
          } else {
            this.get_rank_list()
          }
        })
    },
  },
}
</script>

<style>
.ant-table th,
.ant-table td {
  white-space: nowrap;
}
</style>

<style lang="less" scoped>
.a-img {
  display: flex;
  justify-content: center;
  padding: 0 4px;
  background: #fefefe;

  /deep/ .ant-select-open .ant-select-selection {
    border-color: #eb6c3e;
    box-shadow: 0 0 0 2px rgba(241, 90, 36, 0.2);
  }

  /deep/ .ant-select-focused .ant-select-selection,
  .ant-select-selection:focus,
  .ant-select-selection:active {
    border-color: #f15a24;
    box-shadow: 0 0 0 2px rgba(241, 90, 36, 0.2);
  }

  /deep/ .ant-select-selection:hover {
    border-color: #f15a24;
  }

  > div {
    width: 100%;
  }

  .title {
    text-align: center;
    width: 100%;
    padding: 0.06rem 0;
    font-size: 0.16rem;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0.08rem;
    &:after {
      content: ' ';
      display: block;
      width: 0.28rem;
      height: 0.025rem;
      border-radius: 0.02rem;
      background: #f15a24;
      margin-top: 0.04rem;
    }
    &.noline {
      &:after {
        display: none;
      }
    }
  }

  .t-title {
    font-size: 0.075rem;
    font-weight: bold;
    width: 100%;
    text-align: center;
    padding: 16px;
  }

  .rank-area {
    ul {
      margin: 0;
      padding: 0;
      perspective: -300;
      transform-style: preserve-3d;
      li {
        list-style: none;
        margin: 1px 0;
        background: #fff;
        padding: 8px 0;
        font-size: 0;
        > * {
          font-size: 0.07rem;
        }
        &:nth-child(2n) {
          background: #f1f1f1;
        }
      }
    }

    .thead {
      width: 100%;
      padding: 8px;
      background: rgb(253, 253, 253);

      span {
        font-size: 0.07rem;
        font-weight: bold;
      }
    }

    span {
      padding: 4px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }

    .num {
      width: 10%;
      text-align: center;
    }

    .team {
      width: 40%;
    }

    .lap {
      width: 20%;
    }

    .stime {
      width: 30%;
    }
  }
}
</style>

<style scoped>
.rank >>> .ant-table {
  font-size: 20px;
  background: #fff;
}

.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>
